import { render, staticRenderFns } from "./SvgCopy.vue?vue&type=template&id=363f53b4&scoped=true&"
import script from "./SvgCopy.vue?vue&type=script&lang=js&"
export * from "./SvgCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f53b4",
  null
  
)

export default component.exports